import { Controller } from '@hotwired/stimulus'
import { stringToClassnames } from '../utils'

export default class SwitchController extends Controller {
  declare readonly onClassesValue: string
  declare readonly offClassesValue: string
  declare readonly initialValue: boolean
  declare readonly smoothValue: boolean

  static values = {
    onClasses: {
      type: String,
      default: '',
    },
    offClasses: {
      type: String,
      default: '',
    },
    initial: Boolean,
    smooth: Boolean,
  }

  get onClasses(): string[] {
    return stringToClassnames(this.onClassesValue)
  }

  get offClasses(): string[] {
    return stringToClassnames(this.offClassesValue)
  }

  currentState: boolean
  timeout: NodeJS.Timeout

  connect(): void {
    if (!this.smoothValue) {
      this.#handleInit()
    } else {
      this.#handleToggle(this.initialValue)
      this.timeout = setTimeout(this.#handleInit.bind(this), 100)
    }
  }

  toggle() {
    this.#handleToggle(this.currentState)
  }

  #handleToggle(fromState) {
    if (fromState) {
      this.#handleOff()
    } else {
      this.#handleOn()
    }
  }

  #handleInit() {
    if (this.initialValue) {
      this.#handleOn()
    } else {
      this.#handleOff()
    }
  }

  #handleOn() {
    this.element.classList.remove(...this.offClasses)
    this.element.classList.add(...this.onClasses)
    this.currentState = true
    this.dispatch('on')
  }

  #handleOff() {
    this.element.classList.remove(...this.onClasses)
    this.element.classList.add(...this.offClasses)
    this.currentState = false
    this.dispatch('off')
  }
}
